<template>
  <div class="web_search">
    <!-- 搜索部分 -->
    <div class="search_content">
      <div class="search-input input_item">
        <input
          id="searchInput"
          class="input-box input_input"
          placeholder="请输入您的查询内容"
          type="text"
          autocomplete="off"
          maxlength="500"
          v-model="searchText"
        />
        <span
          class="small-generatePic-btn main-btn-primary btn_search"
          @click="gogogo()"
        >
          查询
        </span>
      </div>
      <div class="input-example example_item">
        <label>示例：</label>
        <span>
          <label class="example-box example-title-font">
            <span
              v-for="(item, index) in lzli"
              :key="index"
              class="example-title"
              style="color: rgba(39, 38, 77, 0.5); cursor: pointer"
              @click="goSearch(item)"
            >
              {{ item + " " }}
            </span>
          </label></span
        >
      </div>
    </div>
    <!-- 左边点击上传 -->
    <div class="upload">
      <div class="result_item_title"><span></span> 图片查找</div>
      <div style="margin-top: 30px">
        <el-upload
          class="avatar-uploader"
          action="https://edam.tscon.cn:7778/apptensorapi/questionanswer3"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="handle_success"
        >
          <!-- :on-success="handleAvatarSuccess" -->
          <img v-if="imageUrl" :src="imageUrl" style="width: 70%" />
          <div v-else>
            <div class="upload-core" style="display: block">
              <img
                src="static/img/upload.svg"
                alt=""
                style="width: 40px; height: 40px"
              />
              <p class="upload-desc">
                拖拽或点击上传不超过10M的JPG、JPEG、PNG图片。
              </p>
            </div>
          </div>
        </el-upload>
      </div>
    </div>

    <div class="reList_content">
      <!-- 右边 -->
      <div class="list_show">
        <div class="list_header">
          <div class="list_header_left">
            <img
              src="static/img/fire.png"
              alt=""
              class="list_header_left_img"
            />
            热搜榜
          </div>
          <div class="list_header_right" @click="refresh">
            <i class="el-icon-refresh" id="refresh"></i>换一换
          </div>
        </div>
        <div
          class="list_show_item"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 300px;
            margin: 5px 0;
            padding: 10px;
            background: #f6f6fb;
            border-radius: 10px;
            font-size: 16px;
            cursor: pointer;
          "
          v-for="(item, index) in dataList"
          :key="index"
          @click="goSearch(item.c_info)"
        >
          <div
            class="list_show_item_left"
            style="display: flex; align-items: center"
          >
            <div
              style="
                border-radius: 50%;
                border: 2px solid rgba(98, 74, 255, 0.5);
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #9195a3;
                font-size: 20px;
              "
            >
              {{ index - 0 + 1 }}
            </div>
            <!-- <img :src="item.url" alt="" class="list_show_item_img" /> -->
          </div>
          <div class="list_show_item_right">
            <div>{{ item.c_info }}</div>
          </div>
        </div>
      </div>

      <div v-if="reList.length > 0">
        <div
          v-for="(item, index) in reList"
          :key="index"
          class="reList_item_content"
        >
          <div
            v-if="item.show"
            class="reList_item"
            style="padding: 20px; width: 50%"
          >
            <div
              style="
                display: flex;
                border-left: 5px solid #624aff;
                padding-left: 10px;
              "
            >
              <a class="reList_item_a">{{ item.name }}</a>
            </div>
            <div style="display: flex">
              <span class="reList_item_span" v-if="item.nameother"
                >别名：{{ item.nameother }}</span
              >
            </div>
            <div style="display: flex">
              <span class="reList_item_span" v-if="item.area"
                >活动范围：{{ item.area }}</span
              >
            </div>
            <div style="display: flex">
              <span class="reList_item_span" v-if="item.description"
                >描述：{{ item.description }}</span
              >
            </div>
            <div>
              <img
                v-if="item.path.indexOf('/images/') > 0"
                style="width: 80%; margin-top: 10px"
                :src="
                  item.path.replace(
                    '/home/tscon/we/mcc/',
                    'https://edam.tscon.cn:7778/'
                  )
                "
              />
              <video
                style="width: 80%; margin-top: 10px"
                controls
                v-if="item.path.indexOf('/Video/') > 0"
              >
                <source
                  :src="
                    item.path.replace(
                      '/home/tscon/we/mcc/',
                      'https://edam.tscon.cn:7778/'
                    )
                  "
                  type="video/mp4"
                />
                <source
                  :src="
                    item.path.replace(
                      '/home/tscon/we/mcc/',
                      'https://edam.tscon.cn:7778/'
                    )
                  "
                  type="video/ogg"
                />
                <source
                  :src="
                    item.path.replace(
                      '/home/tscon/we/mcc/',
                      'https://edam.tscon.cn:7778/'
                    )
                  "
                  type="video/webm"
                />
                <object data="movie.mp4" width="320" height="240">
                  <embed
                    :src="
                      item.path.replace(
                        '/home/tscon/we/mcc/',
                        'https://edam.tscon.cn:7778/'
                      )
                    "
                    width="320"
                    height="240"
                  />
                </object>
              </video>
            </div>
          </div>
        </div>
        <div style="height: 20px"></div>
      </div>
      <div v-if="reList.length == 0">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            margin-top: 20vh;
          "
        >
          <img src="./nodata.svg" alt="" />
        </div>
        <!-- 暂无数据 -->
      </div>
    </div>
  </div>
</template>
<script>
import userapi from "@/api/user";
export default {
  components: {},
  data() {
    return {
      searchText: "",
      lzli: [],
      reList: [],
      loading: false,
      imageUrl: "",
      dataList: [],
      count: 5,
      index: 1,
      hotSearchList: [
        {
          url: require("./user.jpg"),
          title: "雅鲁藏布江",
        },
        {
          url: require("./user.jpg"),
          title: "雅鲁藏布江",
        },
        {
          url: require("./user.jpg"),
          title: "雅鲁藏布江",
        },
        {
          url: require("./user.jpg"),
          title: "雅鲁藏布江",
        },
        {
          url: require("./user.jpg"),
          title: "雅鲁藏布江",
        },
      ],
    };
  },
  mounted() {
    userapi
      .getRequest("/api/getRackSerach", {
        type: 2,
        count: this.count * this.index,
      })
      .then((res) => {
        var re = [];
        for (var a = 0; a < res.data.length; a++) {
          re.push(res.data[a].c_info);
        }
        console.log("res", res);
        this.dataList = res.data;
        this.lzli = re;
      });

    userapi
      .getRequest("/search/questionanswer2", {
        keyword: "雅鲁藏布江",
      })
      .then((res) => {
        // loading.close();
        for (var a = 0; a < this.reList.length; a++) {
          this.reList[a].show = false;
        }
        for (var a = 0; a < res.data.data.length; a++) {
          res.data.data[a].show = true;
        }
        this.reList.push(...res.data.data);
      })
      .catch((error) => {
        loading.close();
        this.$message.error("请确认需要检索内容");
        console.log("error", error);
      });
  },
  methods: {
    getImgBase64(file, callback) {
      var url = "";
      //创建文件阅读器
      var reader = new FileReader();
      //创建图片
      var img = new Image();
      //读取为数据url
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        img.src = e.target.result;
        img.onload = () => {
          var canvas = document.createElement("canvas");
          var context = canvas.getContext("2d");
          //核心Js就这个图片绘制成canvas
          context.drawImage(img, 0, 0);
          //canvas绘制的图片转换成base64格式信息
          url = canvas.toDataURL();
          callback(url);
        };
      };
    },
    gogogo() {
      if (this.searchText == "") {
        alert("请输入内容");
        return;
      }
      this.reList = [];
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/search/questionanswer2", {
          keyword: this.searchText,
        })
        .then((res) => {
          loading.close();
          for (var a = 0; a < this.reList.length; a++) {
            this.reList[a].show = false;
          }
          for (var a = 0; a < res.data.data.length; a++) {
            res.data.data[a].show = true;
          }
          this.reList.push(...res.data.data);
        })
        .catch((error) => {
          loading.close();
          this.$message.error("请确认需要检索内容");
          console.log("error", error);
        });
    },
    goSearch(item) {
      this.searchText = item;
      this.gogogo();
    },
    refresh() {
      let dom = document.getElementById("refresh");
      dom.classList.add("rotage");
      setTimeout(() => {
        dom.classList.remove("rotage");
      }, 500);
      this.index++;
      userapi
        .getRequest("/api/getRackSerach", {
          type: 2,
          count: this.count * this.index,
        })
        .then((res) => {
          if (res.data.length >= 30) {
            this.index = 1;
            this.dataList = res.data.slice(
              this.count * (this.index - 1),
              this.count * this.index
            );
          } else {
            this.dataList = res.data.slice(
              this.count * (this.index - 1),
              this.count * this.index
            );
          }
          // this.lzli = re;
        });
    },
    handle_success(res) {
      if (res.status == 0) {
        this.reList = [];
        for (var a = 0; a < this.reList.length; a++) {
          this.reList[a].show = false;
        }
        this.reList = [
          {
            path: res.data.imgpath,
            name: res.data.name,
            description: res.data.description,
            area: res.data.area,
            nameother: res.data.nameother,
            show: true,
          },
        ];
      } else {
        alert(res.data);
      }
    },
    beforeAvatarUpload(file) {
      let binaryData = [];
      binaryData.push(file);
      this.imageUrl = window.URL.createObjectURL(new Blob(binaryData));
    },
  },
};
</script>

<style scoped>
.web_search {
  width: 100%;
  height: 100%;
}

.input_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 876px;
  height: 55px;
  padding-left: 28px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-family: "Microsoft YaHei" !important;
  font-variant: tabular-nums;
  line-height: 1.5715;
  background-color: hsla(0, 0%, 100%, 0.6);
  border: 1px solid rgba(44, 43, 71, 0.15);
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(44, 43, 71, 0.05);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-align: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-box-pack: justify;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.input_input {
  box-sizing: border-box;
  width: 70%;
  height: 100%;
  margin: 0;
  margin-right: 24px;
  overflow: visible;
  color: #27264d;
  font-weight: 500;
  font-size: 26px;
  font-family: Microsoft YaHei;
  line-height: 72px;
  background: none;
  border: 0;
  outline: none;
  -webkit-appearance: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-direction: normal;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.btn_search {
  display: inline-block;
  box-sizing: border-box;
  width: 160px;
  height: 55px;
  margin-right: -1px;
  color: #fff;
  font-weight: 400;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-variant: tabular-nums;
  line-height: 55px;
  text-align: center;
  background-color: #624aff;
  border-radius: 0 11px 11px 0;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-direction: normal;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.search_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
}
.example_item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 876px;
  padding-top: 10px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-family: "Microsoft YaHei" !important;
  font-variant: tabular-nums;
  line-height: 1.5715;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-align: center;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.search-input {
  margin: 0px auto;
}
.input-example {
  margin: 0px auto;
}
.upload {
  position: fixed;
  top: 75vh;
  right: 1%;
  width: 260px;
  padding: 10px;
  background: #f6f6fb;
  border-radius: 10px;
  box-shadow: 0 10px 10px 0 rgba(44, 43, 71, 0.05);
}
.result_item_title {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.result_item_title span {
  display: inline-block;
  width: 5px;
  height: 25px;
  margin-right: 10px;
  background-color: #624aff;
}
.upload-core {
  padding: 20px 10px;
  border: 1.5px dashed #624aff;
  border-radius: 10px;
}
.upload-desc {
  width: 100%;
  margin: 5px auto;
  font-size: 14px;
}
.list_show {
  position: absolute;
  top: 25vh;
  right: 18vw;
  z-index: 100;
  padding: 20px;
}
.list_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 16px;
}
.list_show_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 300px;
  margin: 5px 0;
  padding: 10px;
  font-size: 18px;
  background: #f6f6fb;
  border-radius: 10px;
  /* border-radius: 10px; */
}
.list_show_item_left {
  /* width: 60px;
  height: 60px; */
}
.list_show_item_img {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}
.list_show_item_right {
  margin-left: 10px;
}
.list_header_left {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.list_header_left_img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.list_header_right {
  color: #9195a3;
  font-size: 14px;
  cursor: pointer;
}
.rotage {
  animation: rotateIcon 2s !important;
}
.el-icon-refresh:active {
  animation: rotateIcon 2s !important;
}
@keyframes rotateIcon {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.reList_content {
  width: 100%;
  height: 72vh;
  margin-top: 30px;
  overflow-y: auto;
}
.reList_item {
  margin-top: 20px;
  margin-left: 120px;
  padding: 20px !important;
  background: rgb(246, 246, 251);
  border-radius: 20px;
}
.reList_item_a {
  padding-top: 10px;
  padding-left: 10px;
  color: #000e28;
  font-weight: 400;
  font-size: 16px;
  text-decoration: none;
  border-left: 2px solid #624aff;
}
.reList_item_span {
  margin-top: 10px;
  margin-left: 20px;
  color: #000e28;
  font-weight: 400;
  font-size: 16px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/web.vue